import React from 'react';
import './Header.css';
import SearchIcon from '@material-ui/icons/Search';
import ShoppingIcon from '@material-ui/icons/ShoppingBasket';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { auth } from '../firebase';

const mapStateToProps = (state) => {
  return {
    Basket: state.Basket,
    user: state.User,
  };
};

function Header(props) {
  console.log('user header', props.user);
  const handelAuthontication = () => {
    if (props.user) {
      auth.signOut();
      console.log(props.user.user, 'from heade');
    }
  };

  return (
    <div className="header">
      <Link to="/">
        <img
          src="http://pngimg.com/uploads/amazon/amazon_PNG11.png"
          className="header_logo"
          alt=""
        />
      </Link>
      <div className="header__search">
        <input className="header_searchinput" type="text" />
        <SearchIcon className="header_searchIcon" />
      </div>
      <div className="header_nav">
        <Link to={!props.user?.user ? 'Login' : '/'}>
          <div className="header_option" onClick={handelAuthontication}>
            <span className="header_optionLineOne">
              {props.user?.user
                ? 'hello ' + props.user?.user?.email
                : ' Hello Gust'}
            </span>

            <span className="header_optionLineTow">
              {props.user?.user ? 'Sign Out' : 'Sign In'}
            </span>
          </div>
        </Link>
        <Link to="orders">
          <div className="header_option">
            <span className="header_optionLineOne">Return</span>
            <span className="header_optionLineTow">& Orders </span>
          </div>
        </Link>
        <div className="header_option">
          <span className="header_optionLineOne">Your</span>
          <span className="header_optionLineTow">Prime </span>
        </div>
        <Link to="checkout">
          <div className="header_optionBasket">
            <ShoppingIcon />
            <span className="header_optionLineTow header_BasketCount">
              {props.Basket?.length}
            </span>
          </div>
        </Link>
      </div>
    </div>
  );
}

export default connect(mapStateToProps)(Header);
